import React, { useEffect, useState } from "react";
import {
  Card,
  Select,
  Badge,
  Button,
  Dropdown,
  List,
  Modal,
  Popover,
  Progress,
  Typography,
  Upload,
  Tag,
  Col,
  Row,
  Space,
  message,
} from "antd";
import { DownloadOutlined, InboxOutlined } from "@ant-design/icons";
import { API_URL, host } from "../../constants";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import ErrorModal from "../modal/ErrorsModal";
import dayjs from "dayjs";
import "dayjs/locale/ro.js";
dayjs.locale("ro");
const { Dragger } = Upload;
const { Text } = Typography;

let interval;
const btns = ["facturi", "contoare", "contracte"];

const allowedFilenames = [
  // "address",
  // "banca",
  "luc",
  "apartament",
  // "calculation",
  // "calcultype",
  // "customers",
  "indice",
  // "object",
  // "region",
  // "serv_apart",
  // "serv_furn",
  // "service",
  // "street",
  // "universal"
  // "diferente",
];

const MultiUploadContainer = () => {
  const [blockedButtons, setBlockedButtons] = useState([]);
  const [errorBtns, setErrorBtns] = useState(null);
  const [dates, setDates] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [an, setAn] = useState(2025);
  const [ln, setLn] = useState(2);
  const [blocked, setBlocked] = useState(false);
  const [blockedClientIndici, setBlockedClientIndici] = useState(false);
  const [monthBlocked, setMonthBlocked] = useState(false);
  const accessToken = useSelector(
    (state) => state.user.currentUser?.accessToken
  );
  const [visible, setVisible] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [docType, setDocType] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpload = ({ file }) => {
    if (file.status === "done") {
      messageApi.success(`${file.name} încărcat cu succes`);
    } else if (file.status === "error") {
      messageApi.error(`${file.name} încărcarea a eșuat.`);
    }
  };

  function handleDrop(e) {
    console.log("Dropped files", e.dataTransfer.files);
  }

  function handleParsing(name) {
    try {
      axios.get(API_URL + "user/gestionar/startParseXlsx/" + name, {
        headers: { Authorization: "Bearer " + accessToken },
      });
      interval = setInterval(checkStatus, 2000);
    } catch (error) {
      console.log(error);
      messageApi.error(error);
    }
  }

  const checkStatus = async () => {
    try {
      const res = await axios.get(API_URL + "user/gestionar/statusParser");
      const data = Object.keys(res.data).filter(
        (item) => res.data[item].parsing
      );
      console.log({ docType });
      let results = res.data[docType]?.results;
      console.log({ results, data });
      if (results?.failed > 0) {
        console.log("here failed");
        messageApi.error(
          `Failed ${results.failed} rows. Created (${results.created}) and updated (${results.updated}) rows will not be added until all errors are resolved`
        );
      } else if (results?.created || results?.updated) {
        console.log("here succeed");
        messageApi.success(
          `Created (${results.created}) rows and updated (${results.updated}) rows.`
        );
      }
      const errors = Object.keys(res.data).filter(
        (item) => res.data[item].error
      );

      const dates = Object.keys(res.data).filter(
        (item) => res.data[item].lastModified
      );
      const dateMapper = {};
      dates.forEach((date) => {
        dateMapper[date] = [
          {
            key: date,
            label: moment(res.data[date].lastModified).format(
              "DD-MM-YYYY, HH:mm"
            ),
          },
        ];
      });
      console.log({ dateMapper });
      setDates(dateMapper);
      if (errors.length) {
        const errorObject = {};
        errors.forEach((e) => {
          errorObject[e] = res.data[e].error;
        });
        console.log({ errorObject });
        setErrorBtns(errorObject);
      } else {
        setErrorBtns(null);
      }

      if (!data.length) {
        clearInterval(interval);
        setDocType("");
      }
      setBlockedButtons(() => {
        let arr = data.map((item) => {
          return { ...res.data[item], name: item };
        });
        console.log({ arr });
        return arr;
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    interval = setInterval(checkStatus, 2000);
    checkStatus();

    return () => clearInterval(interval);
  }, []);

  const deleteCurrentPlati = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/reset/CurrentPayed",
        {
          headers: { Authorization: "Bearer " + accessToken },
        }
      );
      messageApi.success("Plățile sunt șterse cu succes!");
    } catch (error) {
      console.log(error);
      messageApi.error(error.message);
    } finally {
      setIsOpen(false);
    }
  };

  const handleDelete = () => {
    setIsOpen(true);
  };

  const handleDownload = async (name, message) => {
    try {
      const res = await axios.get(
        `${API_URL}user/gestionar/download/${name}/${ln}/${an}`,
        {
          headers: { Authorization: "Bearer " + accessToken },
          responseType: "blob",
        }
      );
      const blob = new Blob([res.data], {
        type: res.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}.zip`);

      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      messageApi.success(message + " descărcate cu succes!");
    } catch (error) {
      console.log(error);
      messageApi.error(error.message);
    }
  };

  const handleUnlockPages = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/modificari/removeBlockage"
      );
      console.log({ res });
      if (res.status === 200) {
        window.location.reload();
        //  await getBlockStatus();
      }
    } catch (error) {
      console.log({ error });
    }
  };
  const handleBlockPages = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/modificari/setBlockage"
      );
      console.log({ res });
      if (res.status === 200) {
        // await getBlockStatus();

        window.location.reload();
      }
    } catch (error) {
      console.log({ error });
    }
  };
  const getBlockStatus = async () => {
    try {
      const res = await axios.get(
        API_URL + "gestionar/modificari/blockageStatus"
      );
      console.log({ res });
      setBlocked(res.data.blocked);
    } catch (error) {
      console.log({ error });
    }
  };

  const handleUnlockPagesClientIndici = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/client/removeBlockage"
      );
      console.log({ res });
      if (res.status === 200) {
        window.location.reload();
        // await handleBlockPagesClientIndici();
      }
    } catch (error) {
      console.log({ error });
    }
  };
  const handleBlockPagesClientIndici = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/client/setBlockage"
      );
      console.log({ res });
      if (res.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.log({ error });
    }
  };
  const handleUnlockMonth = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/removeMonthBlock"
      );
      console.log({ res });
      if (res.status === 200) {
        window.location.reload();
        // await handleBlockPagesClientIndici();
      }
    } catch (error) {
      console.log({ error });
    }
  };
  const handleBlockMonth = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/setMonthBlock"
      );
      console.log({ res });
      if (res.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.log({ error });
    }
  };
  const getBlockStatusClientIndici = async () => {
    try {
      const res = await axios.get(
        API_URL + "user/gestionar/client/blockageStatus"
      );
      console.log({ res });
      setBlockedClientIndici(res.data.blocked);
    } catch (error) {
      console.log({ error });
    }
  };
  const getBlockStatusMonth = async () => {
    try {
      const res = await axios.get(
        API_URL + "/gestionar/blockageStatus/month"
      );
      console.log({ res });
      setMonthBlocked(JSON.parse(res.data.blocked));
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getBlockStatusClientIndici();
    getBlockStatusMonth();
    getBlockStatus();
  }, []);

  // const handleDownloadMods = async () => {
  //   try {
  //     const res = await axios.get(
  //       API_URL + "user/gestionar/download/modificari/" + ln + "/" + an,
  //       {
  //         headers: { Authorization: "Bearer " + accessToken },
  //         responseType: "blob",
  //       }
  //     );
  //     const blob = new Blob([res.data], {
  //       type: res.headers["content-type"],
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "modificari.zip");

  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     messageApi.success("Modificări descărcate cu succes!");
  //   } catch (error) {
  //     console.log(error);
  //     messageApi.error(error.message);
  //   }
  // };
  // const handleDownloadIndice = async () => {
  //   try {
  //     const res = await axios.get(
  //       API_URL + "user/gestionar/download/indici/" + ln + "/" + an,
  //       {
  //         headers: { Authorization: "Bearer " + accessToken },
  //         responseType: "blob",
  //       }
  //     );
  //     const blob = new Blob([res.data], {
  //       type: res.headers["content-type"],
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "indici.zip");

  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     messageApi.success("Indici descărcate cu succes!");
  //   } catch (error) {
  //     console.log(error);
  //     messageApi.error(error.message);
  //   }
  // };
  // const handleDownloadNume = async () => {
  //   try {
  //     const res = await axios.get(
  //       API_URL + "user/gestionar/download/modificarinume/" + ln + "/" + an,
  //       {
  //         headers: { Authorization: "Bearer " + accessToken },
  //         responseType: "blob",
  //       }
  //     );
  //     const blob = new Blob([res.data], {
  //       type: res.headers["content-type"],
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "nume.zip");

  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     messageApi.success("Numele descărcate cu succes!");
  //   } catch (error) {
  //     console.log(error);
  //     messageApi.error(error.message);
  //   }
  // };

  // const handleDownloadLUC = async () => {
  //   try {
  //     const res = await axios.get(
  //       API_URL + "user/gestionar/download/luc/" + ln + "/" + an,
  //       {
  //         headers: { Authorization: "Bearer " + accessToken },
  //         responseType: "blob",
  //       }
  //     );
  //     const blob = new Blob([res.data], {
  //       type: res.headers["content-type"],
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "luc.zip");

  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     messageApi.success("LUC descărcate cu succes!");
  //   } catch (error) {
  //     console.log(error);
  //     messageApi.error(error.message);
  //   }
  // };

  // const handleDownloadContoare = async () => {
  //   try {
  //     const res = await axios.get(
  //       API_URL + "user/gestionar/download/contoare/" + ln + "/" + an,
  //       {
  //         headers: { Authorization: "Bearer " + accessToken },
  //         responseType: "blob",
  //       }
  //     );
  //     const blob = new Blob([res.data], {
  //       type: res.headers["content-type"],
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "contoare.zip");

  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     messageApi.success("Contoare descărcate cu succes!");
  //   } catch (error) {
  //     console.log(error);
  //     messageApi.error(error.message);
  //   }
  // };
  // const handleDownloadExpiredContoare = async () => {
  //   try {
  //     const res = await axios.get(
  //       API_URL + "user/gestionar/download/contoare_expired/" + ln + "/" + an,
  //       {
  //         headers: { Authorization: "Bearer " + accessToken },
  //         responseType: "blob",
  //       }
  //     );
  //     const blob = new Blob([res.data], {
  //       type: res.headers["content-type"],
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "contoare_expired.zip");

  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     messageApi.success("Contoare Expirare descărcate cu succes!");
  //   } catch (error) {
  //     console.log(error);
  //     messageApi.error(error.message);
  //   }
  // };
  // const handleDownloadRecalcule = async () => {
  //   try {
  //     const res = await axios.get(
  //       API_URL + "user/gestionar/download/recalcule/" + ln + "/" + an,
  //       {
  //         headers: { Authorization: "Bearer " + accessToken },
  //         responseType: "blob",
  //       }
  //     );
  //     const blob = new Blob([res.data], {
  //       type: res.headers["content-type"],
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "recalcule.zip");

  //     document.body.appendChild(link);

  //     link.click();

  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     messageApi.success("Recalcule descărcate cu succes!");
  //   } catch (error) {
  //     console.log(error);
  //     messageApi.error(error.message);
  //   }
  // };
  const handleDownloadBanks = async (type) => {
    const route =
      type === "facturi"
        ? "getBankInvoices"
        : type === "contoare"
        ? "getBankMeters"
        : type === "contracte"
        ? "getBankContracts"
        : "";
    try {
      setLoading(true);
      const res = await fetch(API_URL + "/gestionar/banks/" + route);

      console.log(res);
      if (!res.ok) throw new Error("Failed to generate export file");

      // Get filename from Content-Disposition
      const disposition = res.headers.get("Content-Disposition");
      const match = disposition?.match(/filename="?([^"]+)"?/);
      const fileName = match ? match[1] : type + ".txt";

      // Download blob
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      messageApi.success("TXT file downloaded!");
    } catch (err) {
      console.error(err);
      messageApi.error("Error generating TXT file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {contextHolder}
      <Row gutter={24}>
        <Col>
          <Row gutter={24}>
            <Col xs={12}>
              <Row>
                <Col xs={24}>
                  {/* <Card title={"Access Prezentare Indici"}> */}
                  <Card title={"Access Modificare Luna Curenta"}>
                    {/* <span>
                      In data de 1 a fiecarei luni, compartimentul{" "}
                      <a
                        href={"https://invoicer.md/factura/"}
                        target={"_blank"}
                      >
                        "Prezentare Indici"
                      </a>{" "}
                      va fi dezactivat automat
                    </span> */}
                    Puteți dezactiva posibilitatea de a edita datele lunii curente.
                    <div>
                      <span>Status: </span>
                      {/* {blockedClientIndici ? ( */}
                      {monthBlocked ? (
                        <Tag color="#f50">
                          {/* Utilizatorii NU pot prezenta indicii */}
                          Utilizatorii introduc date pentru luna:  {dayjs().subtract(1, "month").format("MMMM")}
                        </Tag>
                      ) : (
                        <Tag color="#87d068">
                          {/* Utilizatorii pot prezenta indicii */}
                          Utilizatorii introduc date pentru luna:  {dayjs().format("MMMM")}
                        </Tag>
                      )}
                    </div>
                    <hr />
                    <div>
                      {/* {blockedClientIndici ? ( */}
                      {monthBlocked ? (
                        <Button
                          type="primary"
                          variant="solid"
                          color="success"
                          size={"small"}
                          // disabled={blockedButtons.length}
                          // onClick={handleUnlockPagesClientIndici}
                          onClick={handleUnlockMonth}
                          className="unlock-button"
                        >
                          {/* Permite Prezentare Indici */}
                          Inchide luna de calcul {dayjs().subtract(1, "month").format("MMMM")}
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          size={"small"}
                          variant="solid"
                          color="success"
                          // disabled={blockedButtons.length}
                          // onClick={handleBlockPagesClientIndici}
                          onClick={handleBlockMonth}
                          className="danger-button"
                        >
                          {/* Blocheaza Prezentare Indici */}
                          Deschide luna de calcul {dayjs().subtract(1, "month").format("MMMM")}
                        </Button>
                      )}
                    </div>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col xs={12}>
              <div>
                <Card title={"Descarcare modificari"}>
                  <Row>
                    <Col>
                      <Space>
                        <Select
                          placeholder={"Selecteaza luna"}
                          onSelect={(el) => setLn(el)}
                          options={[...Array(12)].map((_, i) => ({
                            value: `${i + 1}`,
                            label: `${i + 1}`,
                          }))}
                        />
                        <Select
                          placeholder={"Selecteaza anul"}
                          onSelect={(el) => setAn(el)}
                          options={["2024", "2025"].map((year) => ({
                            value: year,
                            label: year,
                          }))}
                        />
                      </Space>
                    </Col>
                  </Row>
                  <hr className="mb-3 mt-2" />
                  <div className="d-flex flex-column gap-3 p-2">
                    <Space wrap>
                      <Button
                        type="primary"
                        variant="solid"
                        disabled={blockedButtons.length}
                        onClick={() =>
                          handleDownload("modificari", "Modificări")
                        }
                      >
                        Modificari
                      </Button>
                      <Button
                        type="primary"
                        variant="solid"
                        disabled={blockedButtons.length}
                        onClick={() => handleDownload("indici", "Indici")}
                      >
                        Indici
                      </Button>
                      <Button
                        type="primary"
                        variant="solid"
                        disabled={blockedButtons.length}
                        onClick={() =>
                          handleDownload("modificarinume", "Numele")
                        }
                      >
                        Nume
                      </Button>
                      <Button
                        type="primary"
                        variant="solid"
                        disabled={blockedButtons.length}
                        onClick={() => handleDownload("luc", "LUC")}
                      >
                        LUC
                      </Button>

                      <Button
                        type="primary"
                        variant="solid"
                        disabled={blockedButtons.length}
                        onClick={() => handleDownload("contoare", "Contoare")}
                      >
                        Modificari Contoare
                      </Button>

                      <Button
                        type="primary"
                        variant="solid"
                        disabled={blockedButtons.length}
                        onClick={() =>
                          handleDownload(
                            "contoare_expired",
                            "Contoare Expirare"
                          )
                        }
                      >
                        Expirare Contoare
                      </Button>

                      <Button
                        type="primary"
                        variant="solid"
                        disabled={blockedButtons.length}
                        onClick={() => handleDownload("recalcule", "Recalcule")}
                      >
                        Recalcule
                      </Button>
                    </Space>
                  </div>
                </Card>
                <Card title="Export lunar banca" className="rounded-2xl shadow-md">
                  <p style={{ marginBottom: 20 }}>
                    Generați și descărcați exportul TXT pentru luna precedentă.
                  </p>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {btns.map((btn, i) => (
                      <Button
                        key={i}
                        type="primary"
                        icon={<DownloadOutlined />}
                        loading={loading}
                        onClick={() => handleDownloadBanks(btn)}
                        style={{ textTransform: "capitalize" }}
                      >
                        Descarca {btn}
                      </Button>
                    ))}
                  </div>
                  {/* 
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          loading={loading}
          onClick={() => handleDownload("contoare")}
        >
          Incarca Contoare
        </Button> */}
                </Card>
              </div>
            </Col>
          </Row>
          <hr />
          <Row gutter={24}>
            <Col xs={12}>
              <Dragger
                multiple
                onChange={handleUpload}
                // onRemove={handleRemove}
                onDrop={handleDrop}
                action={host + "/import/upload"}
                name="files"
                style={{ marginBottom: "16px" }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Faceți clic sau trageți fișierul în această zonă pentru a-l
                  încărca
                </p>
                <p className="ant-upload-hint">
                  Suport pentru o singură încărcare sau o încărcare în masă.
                  Este strict interzisă încărcarea datelor companiei sau a altor
                  fișiere interzise.
                </p>
              </Dragger>

              {/* <hr /> */}
            </Col>
            <Col xs={12}>
              <Card title={"Parsing date"}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "4px",
                    maxWidth: 400,
                  }}
                >
                  {allowedFilenames.map((filename, index) => {
                    const items = [];
                    if (dates && dates?.[filename]?.length) {
                      items.push(...dates?.[filename]);
                    }
                    if (errorBtns && errorBtns?.[filename]?.length) {
                      items.push({
                        key: filename + "_error",
                        label:
                          "See " +
                          (errorBtns?.[filename]?.length || 0) +
                          " errors",
                        // onClick: setVisible(filename),
                      });
                    }
                    return (
                      <Badge key={index} dot={errorBtns && errorBtns[filename]}>
                        <Popover
                          trigger={"hover"}
                          title={
                            errorBtns && errorBtns?.[filename] ? null : null
                          }
                        >
                          <Dropdown.Button
                            type="primary"
                            disabled={blockedButtons.length}
                            onClick={() => {
                              setDocType(filename);
                              handleParsing(filename);
                              // setBlocked(true);
                              setBlockedButtons([
                                { name: filename, status: 0 },
                              ]);
                            }}
                            menu={{
                              items,
                              onClick: ({ key }) => {
                                const splitApart = key.split("_");
                                if (
                                  splitApart.length > 1 &&
                                  splitApart[1] === "error"
                                ) {
                                  setVisible(splitApart[0]);
                                }
                              },
                            }}
                            style={{
                              width: 200,
                              display: "flex",
                              alignItems: "stretch",
                            }}
                            className="dropdown-parsing"
                          >
                            {filename}
                          </Dropdown.Button>
                        </Popover>
                      </Badge>
                    );
                  })}
                </div>

                {blockedButtons.length ? (
                  <List
                    dataSource={blockedButtons}
                    size="small"
                    renderItem={(item) => (
                      <List.Item style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            alignItems: "stretch",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "10px",
                              width: "100%",
                            }}
                          >
                            <Text style={{ wordBreak: "keep-all" }}>
                              {item.name}
                            </Text>

                            <Text
                              type={
                                parseInt(item.status) > 50
                                  ? "success"
                                  : "warning"
                              }
                            >
                              {item.status ?? 0}%
                            </Text>
                          </div>
                          <Progress
                            percent={item.status ?? 0}
                            size="default"
                            strokeColor={
                              parseInt(item.status) > 50 ? "#52c41a" : "#faad14"
                            }
                            showInfo={false} // Hides the percentage inside the bar
                            style={{ flex: 1, margin: 0 }}
                          />
                        </div>
                      </List.Item>
                    )}
                  />
                ) : null}
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal
        open={isOpen}
        onOk={deleteCurrentPlati}
        onCancel={() => setIsOpen(false)}
      >
        Doriți să ștergeți toate plățile curente?
      </Modal>
      {visible ? (
        <ErrorModal
          visible={visible}
          onClose={() => setVisible("")}
          errors={errorBtns}
        />
      ) : null}
    </div>
  );
};

export default MultiUploadContainer;
